import { ComponentDefinition } from '@contentful/experiences-sdk-react';

export const insightCardDefinition: ComponentDefinition = {
  id: 'insightCard',
  name: 'Insight Card',
  category: 'Custom',
  thumbnailUrl: 'https://unpkg.com/lucide-static/icons/newspaper.svg',
  variables: {
    image: {
      type: 'Media',
      displayName: 'Image',
      validations: { bindingSourceType: ['asset'] },
    },
    imageAlt: {
      type: 'Text',
      displayName: 'Image Alt Text',
      validations: { bindingSourceType: ['manual', 'experience', 'entry', 'asset'] },
    },
    tags: {
      type: 'Text',
      displayName: 'Tags (comma-separated)',
      validations: { bindingSourceType: ['manual', 'experience', 'entry', 'asset'] },
    },
    title: {
      type: 'Text',
      displayName: 'Title',
      validations: { bindingSourceType: ['manual', 'experience', 'entry', 'asset'] },
    },
    description: {
      type: 'Text',
      displayName: 'Description',
      validations: { bindingSourceType: ['manual', 'experience', 'entry', 'asset'] },
    },
    date: {
      type: 'Text',
      displayName: 'Date (ISO)',
      validations: { bindingSourceType: ['manual', 'experience', 'entry', 'asset'] },
    },
    minRead: {
      type: 'Number',
      displayName: 'Min Read',
      validations: { bindingSourceType: ['manual', 'experience', 'entry', 'asset'] },
    },
    ctaLabel: {
      type: 'Text',
      displayName: 'CTA Label',
      defaultValue: 'Read more',
      validations: { bindingSourceType: ['manual', 'experience', 'entry', 'asset'] },
    },
    ctaUrl: {
      type: 'Text',
      displayName: 'CTA URL',
      validations: { bindingSourceType: ['manual', 'experience', 'entry', 'asset'] },
    },
  },
} as const;
